import { App, Plugin } from 'vue';

import proj4 from 'proj4';
import { register } from 'ol/proj/proj4.js';

const INSTALLED = Symbol('mapPluginInstalled');

export const AppMapPlugin: Plugin = {
	install: (app: App /*options?: ApplicationOptions*/) => {
		// Prevent double isntall
		if ((app as any)[INSTALLED]) return;
		(app as any)[INSTALLED] = true;

		// Setup proj4 with available transformations
		proj4.defs('EPSG:25832', '+proj=utm +zone=32 +datum=ETRS89 +units=m +no_defs');
		proj4.defs('EPSG:25833', '+proj=utm +zone=33 +datum=ETRS89 +units=m +no_defs');
		register(proj4);
	},
};

export default AppMapPlugin;
